export default __webpack_public_path__ + "static/laravel-development-company-peerbits-60d4a18439c450d4ed5436f0cac9cce6.png";